export enum StubsCellBlock {
  Root = 'StubsCell',
}
